import { Component, OnInit, ViewChild, ElementRef, Input, Inject } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Title } from '@angular/platform-browser';
import { Router, ActivatedRoute, Params } from '@angular/router';
import * as FileSaver from 'file-saver';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ActionStatusPopupComponent } from 'src/app/Shared/action-status-popup/action-status-popup.component';
import { ApplicationActivityStore } from 'src/common/commonFunction';
import { ApplicationActivityService } from 'src/Services/application-activity.service';
import { updatesModel, updatesPageModel } from 'src/Models/WirelessModel';
import { HtmlToPdf } from 'src/Services/htmlToPdf';
import { CheckAuth } from 'src/Services/utility.service';
import { WirelessService } from 'src/Services/wireless.service';
import { ActionActivity, ToolEnum } from 'src/Models/Common';
import { AppConfig } from 'src/Services/app.config';
import { SessionStorageService } from 'src/common/session-storage.service';

@Component({
  selector: 'app-wireless-update',
  templateUrl: './update.component.html',
  styleUrls: ['./update.component.css']
})
export class WirelessUpdateComponent implements OnInit {
  userID: number = 0;
  isAscending: boolean;
  statusCode: number = 0;
  appModel: any;

  upDowUpdateCategoryNameCSS: string = '';
  upDowStateCSS: string = '';
  upDowUpdateTypeCSS: string = '';
  upDowCreatedByCSS: string = '';
  upDowCreatedDateCSS: string = '';
  upDowModifiedByCSS: string = '';
  upDowModifiedDateCSS: string = '';
  upDowUpdateDateCSS: string = '';

  isloading: boolean = false;
  tokenKey: string = '';
  updatesModel: updatesModel[] = [];
  isRecords: boolean = false;
  isShowprogressSpinner: boolean;
  blockedDocument: boolean = false;
  totalRecordsCount: number = -1;
  deleteupdateId: number = 0;
  @ViewChild('deletecloseBtn', { static: false }) deletecloseBtn: ElementRef;
  queryParams: string = '';
  totalunread: number = 0;
  alldata: string = 'all';
  unreaddata: string = 'unread';
  parameterModel = new updatesPageModel();
  baseUrl: string;

  //State List
  dropdownListState = [];
  selectedItemsState = [];
  dropdownSettingsState = {};
  stateFilter: string = '';

  listOfstateID: string[] = [];
  ClientSelectedTool: string;
  productId: number = 1;

  isActionItemSubscription: boolean = false;

  rangeOfupdatesDates: any;
  wirelessUnreadflag:boolean=true;
  wirelessUnread: number = 0;
  isDisplayAllData:boolean=false;

  constructor(private readonly modalService: NgbModal, 
    @Inject('BASE_URL') baseUrl: string, 
    private readonly htmlToPdf: HtmlToPdf,
    private readonly WirelessService: WirelessService, 
    private readonly toastr: ToastrService,
    private readonly titleService: Title, 
    private readonly checkAuth: CheckAuth,
    private readonly router: Router, 
    private readonly appActivity: ApplicationActivityService,
    private sessionStorageService: SessionStorageService) {
    this.baseUrl = baseUrl;
    this.tokenExpireCalculation(this.sessionStorageService.getAppStartTime(),this.sessionStorageService.getTokenExpiryValue());
    this.userID = +sessionStorage.getItem('UserId');
    this.appModel = AppConfig.settings.ConnectionStrings;
   
    this.ClientSelectedTool = "wireless";
    this.productId = ToolEnum.wireless;
    this.titleService.setTitle('Updates | JSi360');

    // Try to get token
    this.waitForTokenThenInit();
  }

  tokenExpireCalculation(startDate: string, tokenExpiry: string) {
    this.checkAuth.tokenExpireCalculation(startDate, tokenExpiry);
  }

  private waitForTokenThenInit(): void {
    this.tokenKey = this.sessionStorageService.getTokenValue();

    if (!this.tokenKey) {
      console.warn('Token is empty, retrying in 100ms...');
      const interval = setInterval(() => {
        this.tokenKey = this.sessionStorageService.getTokenValue();
        if (this.tokenKey) {
          clearInterval(interval);
          this.afterTokenReady();
        }
      }, 100); // check every 100ms
    } else {
      this.afterTokenReady();
    }
  }

  /** Call what you normally do in ngOnInit */
  private afterTokenReady(): void {
    let wirelessReadflag = sessionStorage.getItem('wirelessUnreadflag');
    this.wirelessUnreadflag = wirelessReadflag === 'true' ? true : false;

    let wirelessUnreadcount = sessionStorage.getItem('wirelessUnread');

    this.wirelessUnread = parseInt(wirelessUnreadcount);

    this.movetotop();
    this.parameterModel.pageIndex = 1;
    this.parameterModel.pageSize = 10;
    this.parameterModel.keywordFilter = 'null';
    this.parameterModel.whereCondition = 'null';
    this.parameterModel.orderBy = 'UpdateDate desc';
    this.upDowUpdateDateCSS = 'active';
    this.isAscending = true;
    this.parameterModel.fromupdatesDateFilter = "null";
    this.parameterModel.toupdatesDateFilter = "null";
    this.parameterModel.userID = this.userID.toString();
    this.parameterModel.updatetype = "1,2";
    
    this.GetUpdates();
    this.GetStateData();
    this.clientHasActionItemSubscription();
  }

  ngOnInit() {
    
  }

  clientHasActionItemSubscription() {
    let clientToolAccess = sessionStorage.getItem('ClientAccessibleTools');
    if (clientToolAccess != null && clientToolAccess != '') {
      let arraySubscription = clientToolAccess.split(',');
      if (arraySubscription.length > 0) {
        let tmpAction = ToolEnum[ToolEnum.actionitem];
        let coun = arraySubscription.filter(m => m === tmpAction);
        if (coun.length > 0)
          this.isActionItemSubscription = true;
        else
          this.isActionItemSubscription = false;
      }
    }
  }

  GetUpdates(): void {
    this.isloading = true;
    this.tokenKey = this.sessionStorageService.getTokenValue();

    if (this.wirelessUnread > 0) {
      this.parameterModel.unreadonly = "1";
      this.isDisplayAllData=false;
    }
    else {
      this.parameterModel.unreadonly = "0";
      this.isDisplayAllData=true;
    }
    this.parameterModel.productId = this.productId.toString();

    this.WirelessService.getupdatesfindByUserID(this.tokenKey, this.parameterModel).subscribe(
      data => {
        this.isloading = false;
        if (data["status"] == "Success") {
          sessionStorage.setItem('wirelessUnreadflag', 'true');
          this.wirelessUnreadflag = true;

          this.updatesModel = data["updates"];
          if (this.updatesModel.length > 0) {
            this.isRecords = true;
            this.totalRecordsCount = parseInt(this.updatesModel[0].totalRecordCount);
            if (this.wirelessUnread>0) {
              this.saveNotification(this.updatesModel);
            }
          }
          else {
            this.totalRecordsCount = 0;
            this.isRecords = false;
          }
        }
        else {
          this.showMessage('There is an issue while fetching data. Please try again.', 'Error', 'error');
        }
      },
      error => {
        this.statusCode = error
      },
    );
  }

  ActiveInactiveUpdates(updateId: any, isactive: any) {
    this.blockDocument();
    this.WirelessService.activeinactiveupdates(this.tokenKey, updateId, isactive)
      .subscribe(data => {
        if (data["status"] == "Success") {
          if (isactive) {
            this.showMessage('Activated successfully', 'Active', 'success');
          }
          else {
            this.showMessage('Inactivated successfully', 'Inactive', 'success');
          }
          this.GetUpdates();
        }
        else {
          this.showMessage(data["status"], 'Error', 'error');
        }
        this.unblockDocument();
      }, error => {
        this.showMessage(error, 'Error', 'error');
        this.unblockDocument();
      })
  }

  sort(sortBy: string) {
    if (!this.isAscending) {
      this.isAscending = true;
      this.parameterModel.orderBy = sortBy + ' DESC';

      if (sortBy === "UpdateCategoryName") {
        this.upDowUpdateCategoryNameCSS = 'active';
        this.upDowStateCSS = '';
        this.upDowUpdateTypeCSS = '';
        this.upDowCreatedByCSS = '';
        this.upDowCreatedDateCSS = '';
        this.upDowModifiedByCSS = '';
        this.upDowModifiedDateCSS = '';
        this.upDowUpdateDateCSS = '';
      }
      else if (sortBy === "StateName") {
        this.upDowUpdateCategoryNameCSS = '';
        this.upDowStateCSS = 'active';
        this.upDowUpdateTypeCSS = '';
        this.upDowCreatedByCSS = '';
        this.upDowCreatedDateCSS = '';
        this.upDowModifiedByCSS = '';
        this.upDowModifiedDateCSS = '';
        this.upDowUpdateDateCSS = '';
      }
      else if (sortBy === "UpdateType") {
        this.upDowUpdateCategoryNameCSS = '';
        this.upDowStateCSS = '';
        this.upDowUpdateTypeCSS = 'active';
        this.upDowCreatedByCSS = '';
        this.upDowCreatedDateCSS = '';
        this.upDowModifiedByCSS = '';
        this.upDowModifiedDateCSS = '';
        this.upDowUpdateDateCSS = '';
      }
      else if (sortBy === "CreatedBy") {
        this.upDowUpdateCategoryNameCSS = '';
        this.upDowStateCSS = '';
        this.upDowUpdateTypeCSS = '';
        this.upDowCreatedByCSS = 'active';
        this.upDowCreatedDateCSS = '';
        this.upDowModifiedByCSS = '';
        this.upDowModifiedDateCSS = '';
        this.upDowUpdateDateCSS = '';
      }
      else if (sortBy === "CreatedDate") {
        this.upDowUpdateCategoryNameCSS = '';
        this.upDowStateCSS = '';
        this.upDowUpdateTypeCSS = '';
        this.upDowCreatedByCSS = '';
        this.upDowCreatedDateCSS = 'active';
        this.upDowModifiedByCSS = '';
        this.upDowModifiedDateCSS = '';
        this.upDowUpdateDateCSS = '';
      }
      else if (sortBy === "ModifiedBy") {
        this.upDowUpdateCategoryNameCSS = '';
        this.upDowStateCSS = '';
        this.upDowUpdateTypeCSS = '';
        this.upDowCreatedByCSS = '';
        this.upDowCreatedDateCSS = '';
        this.upDowModifiedByCSS = 'active';
        this.upDowModifiedDateCSS = '';
        this.upDowUpdateDateCSS = '';
      }
      else if (sortBy === "ModifiedDate") {
        this.upDowUpdateCategoryNameCSS = '';
        this.upDowStateCSS = '';
        this.upDowUpdateTypeCSS = '';
        this.upDowCreatedByCSS = '';
        this.upDowCreatedDateCSS = '';
        this.upDowModifiedByCSS = '';
        this.upDowModifiedDateCSS = 'active';
        this.upDowUpdateDateCSS = '';
      }
      else if (sortBy === "UpdateDate") {
        this.upDowUpdateCategoryNameCSS = '';
        this.upDowStateCSS = '';
        this.upDowUpdateTypeCSS = '';
        this.upDowCreatedByCSS = '';
        this.upDowCreatedDateCSS = '';
        this.upDowModifiedByCSS = '';
        this.upDowModifiedDateCSS = '';
        this.upDowUpdateDateCSS = 'active';
      }
    }
    else {
      this.isAscending = false;
      this.parameterModel.orderBy = sortBy;

      if (sortBy === "UpdateCategoryName") {
        this.upDowUpdateCategoryNameCSS = 'active-up';
        this.upDowStateCSS = '';
        this.upDowUpdateTypeCSS = '';
        this.upDowCreatedByCSS = '';
        this.upDowCreatedDateCSS = '';
        this.upDowModifiedByCSS = '';
        this.upDowModifiedDateCSS = '';
        this.upDowUpdateDateCSS = '';
      }
      else if (sortBy === "StateName") {
        this.upDowUpdateCategoryNameCSS = '';
        this.upDowStateCSS = 'active-up';
        this.upDowUpdateTypeCSS = '';
        this.upDowCreatedByCSS = '';
        this.upDowCreatedDateCSS = '';
        this.upDowModifiedByCSS = '';
        this.upDowUpdateDateCSS = '';
      }
      else if (sortBy === "UpdateType") {
        this.upDowUpdateCategoryNameCSS = '';
        this.upDowStateCSS = '';
        this.upDowUpdateTypeCSS = 'active-up';
        this.upDowCreatedByCSS = '';
        this.upDowCreatedDateCSS = '';
        this.upDowModifiedByCSS = '';
        this.upDowModifiedDateCSS = '';
        this.upDowUpdateDateCSS = '';
      }
      else if (sortBy === "CreatedBy") {
        this.upDowUpdateCategoryNameCSS = '';
        this.upDowStateCSS = '';
        this.upDowUpdateTypeCSS = '';
        this.upDowCreatedByCSS = 'active-up';
        this.upDowCreatedDateCSS = '';
        this.upDowModifiedByCSS = '';
        this.upDowModifiedDateCSS = '';
        this.upDowUpdateDateCSS = '';
      }
      else if (sortBy === "CreatedDate") {
        this.upDowUpdateCategoryNameCSS = '';
        this.upDowStateCSS = '';
        this.upDowUpdateTypeCSS = '';
        this.upDowCreatedByCSS = '';
        this.upDowCreatedDateCSS = 'active-up';
        this.upDowModifiedByCSS = '';
        this.upDowModifiedDateCSS = '';
        this.upDowUpdateDateCSS = '';
      }
      else if (sortBy === "ModifiedBy") {
        this.upDowUpdateCategoryNameCSS = '';
        this.upDowStateCSS = '';
        this.upDowUpdateTypeCSS = '';
        this.upDowCreatedByCSS = '';
        this.upDowCreatedDateCSS = '';
        this.upDowModifiedByCSS = 'active-up';
        this.upDowModifiedDateCSS = '';
        this.upDowUpdateDateCSS = '';
      }
      else if (sortBy === "ModifiedDate") {
        this.upDowUpdateCategoryNameCSS = '';
        this.upDowStateCSS = '';
        this.upDowUpdateTypeCSS = '';
        this.upDowCreatedByCSS = '';
        this.upDowCreatedDateCSS = '';
        this.upDowModifiedByCSS = '';
        this.upDowModifiedDateCSS = 'active-up';
        this.upDowUpdateDateCSS = '';
      }
      else if (sortBy === "UpdateDate") {
        this.upDowUpdateCategoryNameCSS = '';
        this.upDowStateCSS = '';
        this.upDowUpdateTypeCSS = '';
        this.upDowCreatedByCSS = '';
        this.upDowCreatedDateCSS = '';
        this.upDowModifiedByCSS = '';
        this.upDowModifiedDateCSS = '';
        this.upDowUpdateDateCSS = 'active-up';
      }
    }
    this.parameterModel.pageIndex = 1;
    this.GetUpdates();
  }

  pageChanged($event) {
    this.parameterModel.pageIndex = parseInt($event.page);
    this.GetUpdates();
  }

  blockDocument() {
    this.isShowprogressSpinner = true;
    this.blockedDocument = true;
  }

  unblockDocument() {
    this.isShowprogressSpinner = false;
    this.blockedDocument = false;
  }

  showMessage(msg: string, msgTitle: string, msgType: string) {
    if (msgType == 'success') {
      setTimeout(() => this.toastr.success(msg, msgTitle));
    }
    else if (msgType == 'error') {
      setTimeout(() => this.toastr.error(msg, msgTitle));
    }
  }

  movetotop() {
    let scrollToTop = window.setInterval(() => {
      let pos = window.pageYOffset;
      if (pos > 0) {
        window.scrollTo(0, pos - 20); // how far to scroll on each step
      } else {
        window.clearInterval(scrollToTop);
      }
    }, 1);
  }

  keywordFilters($event) {
    this.parameterModel.pageIndex = 1;
    if ($event.target.value != "" && $event.target.value != null)
      this.parameterModel.keywordFilter = $event.target.value;
    else
      this.parameterModel.keywordFilter = 'null';

    this.GetUpdates();
  }

  isupdatesDatesFilter(value: any) {
    this.parameterModel.pageIndex = 1;
    if (value != null) {
      if (value.length == 2) {
        this.parameterModel.pageIndex = 1;
        const d = new Date(value[0]);
        const a = [this.pad(d.getMonth() + 1), this.pad(d.getDate()), d.getFullYear()].join('/');

        const e = new Date(value[1]);
        const f = [this.pad(e.getMonth() + 1), this.pad(e.getDate()), e.getFullYear()].join('/');

        this.parameterModel.fromupdatesDateFilter = a;
        this.parameterModel.toupdatesDateFilter = f;
       this.GetUpdates();
      }
    }
  }

  pad(s) {
    return (s < 10) ? '0' + s : s;
  }

  updatesDateFilterClear() {
    this.rangeOfupdatesDates = [];
    this.parameterModel.fromupdatesDateFilter = "";
    this.parameterModel.toupdatesDateFilter = "";
    this.parameterModel.pageIndex = 1;
    this.GetUpdates();
  }

  viewallupdates() {
    this.wirelessUnread=0;
    this.GetUpdates();
  }

  saveNotification(updates) {
    let _updates = updates;
    for (let iCounter = 0; iCounter < _updates.length; iCounter++) {
      _updates[iCounter].createdBy = this.userID.toString();
    }
    this.WirelessService.addNotification(_updates, this.tokenKey).subscribe(data => {
      if (data.status == 'Success') {
        sessionStorage.setItem('wirelessUnreadflag','true');
        sessionStorage.setItem('wirelessUnread','0');
      }
      else {
        this.showMessage(data.status, 'Error', 'error');
      }
    }, error => {
      this.showMessage(error, 'Error', 'error');
    });
  }

  updatetypechange($event) {
    this.parameterModel.pageIndex = 1;
    if ($event.target.checked) {
      if (this.parameterModel.updatetype == "-1") { this.parameterModel.updatetype = "" }
      if (this.parameterModel.updatetype == '' || this.parameterModel.updatetype == 'null') {
        this.parameterModel.updatetype = $event.target.value;
      }
      else {
        this.parameterModel.updatetype += ',' + $event.target.value;
      }
    }
    else {
      this.parameterModel.updatetype = this.parameterModel.updatetype.replace($event.target.value, "");
      this.parameterModel.updatetype = this.parameterModel.updatetype.replace(/,\s*$/, "");
      this.parameterModel.updatetype = this.parameterModel.updatetype.replace(",,", ",");
      if (this.parameterModel.updatetype.charAt(0) == ",") {
        this.parameterModel.updatetype = this.parameterModel.updatetype.slice(1)
      }
      if (this.parameterModel.updatetype == "") { this.parameterModel.updatetype = "-1" }
    }

    this.GetUpdates();
  }

  navigateToFundDetailByName(stateId: any, stateName: any, title: any, fieldName: any) {
    sessionStorage.setItem('singleStatePreview', stateId);
    sessionStorage.setItem('updatefunddata', title + ' - ' + fieldName);
    ApplicationActivityStore('View', 'Wireless PRO Updates - View History', this.appActivity, ToolEnum.wireless, ActionActivity.Wireless, '/wireless/Matrix/Fund/Details/', stateName);

    let navigation = '/' + this.ClientSelectedTool + '/Matrix/Fund/Details/' + stateName;
    this.router.navigate([navigation]);
  }

  pdfDocument() {
    this.blockDocument();
    let mainURL = this.baseUrl;
    let url = '<link id="adminstyle" rel="stylesheet" href="' + mainURL + '/assets/css/Admin/AdminLTE.min.css"> <br> ';
    url += ' <link rel="stylesheet" href="' + mainURL + '/assets/css/bootstrap.min.css" asp-append-version="true" /> <br> ';
    url += ' <link id="adminstyle" rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/js/bootstrap.min.js"> <br> ';
    var html = url + document.getElementById('divPrint').innerHTML;
    this.htmlToPdf.CreatePDF(this.tokenKey, html, '0',this.productId).
      subscribe(data => {
        if (data['status'] == 'Success') {
          this.downloadFile('Update', data['url']);
        }
      },
        error => {
          this.statusCode = error;
          this.unblockDocument();
        }
      );

  }

  public downloadFile(filename, url) {
    this.htmlToPdf.downloadPdf(url).subscribe(
      (res) => {
        FileSaver.saveAs(res, filename);

        ApplicationActivityStore('Download', 'Wireless PRO Updates File download ' + filename, this.appActivity, ToolEnum.wireless, ActionActivity.Wireless, '/wireless/Update');

        sessionStorage.setItem('fileloading', 'false');
        this.unblockDocument();
      }
    );
  }

  GetStateData(): void {
    this.tokenKey = this.sessionStorageService.getTokenValue();
    this.WirelessService.GetMatrixFundState(this.tokenKey, this.userID, this.productId).subscribe(
      data => {
        if (data["state"] != null) {
          // Set All Item
          for (let iCounter = 0; iCounter < data["state"].length; iCounter++) {
            this.dropdownListState.push(
              { "id": data["state"][iCounter].stateId, "itemName": data["state"][iCounter].name }
            );
          }
        }
        else {
          this.showMessage(data["message"], 'Error', 'error');
          this.unblockDocument();
        }
        this.dropdownSettingsState = {
          singleSelection: false,
          text: "Select State(s)",
          enableSearchFilter: false,
          classes: "borderLessTextBoxGreen",
          badgeShowLimit: 1,
          noDataLabel: 'No state available',
          showCheckbox: true,
          enableFilterSelectAll: false
        };
      }, error => {
        this.showMessage(error, 'Error', 'error');
        this.unblockDocument();
      })
  }

  FilterSelecteventState($event) {
    this.stateFilter = '';
    this.listOfstateID = this.removeElemetninArray(this.listOfstateID, $event['id']);
    this.listOfstateID.push($event.id);
    this.getString(this.listOfstateID);
    this.parameterModel.keywordFilter = this.stateFilter;
    this.parameterModel.pageIndex = 1;
    this.GetUpdates();
  }

  FilterDeSelectseventState($event) {
    this.stateFilter = '';
    this.listOfstateID = this.removeElemetninArray(this.listOfstateID, $event['id']);
    this.getString(this.listOfstateID);
    this.parameterModel.keywordFilter = this.stateFilter;
    this.parameterModel.pageIndex = 1;
    this.GetUpdates();
  }

  removeElemetninArray(array, element) {
    return array.filter(e => e != element);
  }

  getString(array: any) {
    let sprator = '';
    this.stateFilter = '';
    for (let iCounter = 0; iCounter < array.length; iCounter++) {
      this.stateFilter += sprator + array[iCounter];
      sprator = ',';
    }
  }

  onSelectAllStateList($event) {
    this.stateFilter = '';
    if ($event != "" && $event != null) {
      for (let iCounter = 0; iCounter < $event.length; iCounter++) {
        this.listOfstateID = this.removeElemetninArray(this.listOfstateID, $event[iCounter].id);
        this.listOfstateID.push($event[iCounter].id);
      }
      this.getString(this.listOfstateID);
      this.parameterModel.keywordFilter = this.stateFilter;
    }

    this.parameterModel.pageIndex = 1;
    this.GetUpdates();
  }

  onDeSelectAllStateList($event) {
    this.listOfstateID = [];
    this.stateFilter = '';
    this.parameterModel.keywordFilter = '';
    this.parameterModel.pageIndex = 1;
    this.GetUpdates();
  }

  OpenActionStatusPopup(actionId: any, updateId: any, briefingId) {

    let prodid = ToolEnum.actionitem.toString();
    sessionStorage.setItem('productId', prodid);
    sessionStorage.setItem('actionId', actionId);
    sessionStorage.setItem('updateId', updateId);
    sessionStorage.setItem('briefingId', briefingId);
    const modalRef = this.modalService.open(ActionStatusPopupComponent, { size: 'lg' }).result.then(
      result => {
        if (result == 'Yes') {
          // this.GetDashboardActionItemsReuiredAttention();
        }
      },
      reason => {
      });
  }

  ngAfterViewInit() {
    this.setEmailAutoLoginParameter();
  }

  setEmailAutoLoginParameter() {
    if (sessionStorage.getItem('DisplayMessage') != null) {
      this.showMessage(sessionStorage.getItem('DisplayMessage') + ' - user not have access', 'Error', 'error');
      sessionStorage.removeItem('DisplayMessage');
    }
  }
}
